// // import React, { useState, useEffect, useCallback } from 'react';
// // import { useNavigate } from 'react-router-dom';
// // import { useDispatch, useSelector } from 'react-redux';
// // import { logout } from '../redux/slices/authSlice';
// // import {
// //     fetchOverviewRequest,
// //     fetchUsersRequest,
// //     fetchDeletedRequest,
// //     fetchUserDetailsRequest,
// //     adminActionRequest
// // } from '../redux/slices/adminSlice';
// // import * as api from '../api';
// // import SEO from '../components/SEO';
// // import {
// //     ShieldAlert, Plus, RefreshCw, Tag, Ban, Trash2, Edit, LogOut,
// //     Play, Pause, CheckCircle, Users, IndianRupee, MapPin,
// //     Activity, Archive, Search, Radio, Wifi, ArrowDownToLine, ArrowUpFromLine
// // } from 'lucide-react';

// // const Admin = () => {
// //   const [activeTab, setActiveTab] = useState('overview');
// //   const [expandedLicense, setExpandedLicense] = useState(null);

// //   // Live Network State
// //   const [liveData, setLiveData] = useState({ active_users: 0, connections: [] });
// //   const [liveLoading, setLiveLoading] = useState(false);

// //   // Local states for Forms
// //   const [formData, setFormData] = useState({ email: '', users: 10, months: 12 });
// //   const [couponData, setCouponData] = useState({ code: '', discount: 10, valid_days: 30 });
// //   const [pricingData, setPricingData] = useState({ name: '', min_users: 1, max_users: 9, price: 500 });
// //   const [locationData, setLocationData] = useState({ name: '', ip: '' });
// //   const [editMode, setEditMode] = useState(false);

// //   const [editedUser, setEditedUser] = useState({
// //     name: '', email: '', account_type: 'single', org_details: '', gst_number: ''
// //   });

// //   const navigate = useNavigate();
// //   const dispatch = useDispatch();

// //   const { token } = useSelector(state => state.auth);
// //   const adminData = useSelector(state => state.admin);

// //   // 1. Memoized Fetch Function
// //   const fetchLiveConnections = useCallback(async (showLoading = false) => {
// //       try {
// //           if (showLoading) setLiveLoading(true);
// //           const res = await api.getLiveConnections();
// //           setLiveData(res.data);
// //       } catch (err) {
// //           console.error("Failed to fetch live connections", err);
// //       } finally {
// //           setLiveLoading(false);
// //       }
// //   }, []);

// //   // 2. Memoized Refresh Function
// //   const refreshTabContent = useCallback(() => {
// //     if (activeTab === 'overview') dispatch(fetchOverviewRequest());
// //     else if (activeTab === 'users') dispatch(fetchUsersRequest());
// //     else if (activeTab === 'deleted') dispatch(fetchDeletedRequest());
// //     else if (activeTab === 'live') fetchLiveConnections(true);
// //   }, [activeTab, dispatch, fetchLiveConnections]);

// //   // 3. Initial Load & Tab Switching
// //   useEffect(() => {
// //       if(!token) navigate('/login');
// //       else refreshTabContent();
// //   }, [token, navigate, refreshTabContent]);

// //   // 4. Live Network Polling
// //   useEffect(() => {
// //       let interval;
// //       if (activeTab === 'live') {
// //           // refreshTabContent handles the initial fetch, so we just set the background interval here
// //           interval = setInterval(() => fetchLiveConnections(false), 10000);
// //       }
// //       return () => clearInterval(interval);
// //   }, [activeTab, fetchLiveConnections]);

// //   const handleLogout = () => { dispatch(logout()); navigate('/login'); };

// //   const handleAction = (apiCall, params, successMsg, emailForRefresh = null) => {
// //       dispatch(adminActionRequest({
// //           apiCall,
// //           params,
// //           successMsg,
// //           refreshAction: activeTab === 'overview' ? fetchOverviewRequest : (activeTab === 'users' ? fetchUsersRequest : fetchDeletedRequest),
// //           emailForDetailsRefresh: emailForRefresh
// //       }));
// //   };

// //   const handleUpdateUser = (e) => {
// //       e.preventDefault();
// //       handleAction((uData) => api.adminUpdateUser(uData.email, uData), editedUser, "User Profile Updated", editedUser.email);
// //       setEditMode(false);
// //   };

// //   const handleToggleBan = (email, isBanned) => {
// //       if(!window.confirm(`${isBanned ? 'Unban' : 'Suspend'} this account?`)) return;
// //       handleAction(api.toggleBanUser, { email }, "Account Status Updated", email);
// //   };

// //   const handleDeleteUser = (email) => {
// //       if(!window.confirm("Hard delete and move to backups? This action is permanent.")) return;
// //       handleAction(api.adminDeleteUser, email, "Account Deleted & Backed Up");
// //   };

// //   const handleGenerate = (e) => {
// //     e.preventDefault();
// //     if(!window.confirm(`Generate FREE license for ${formData.email}?`)) return;
// //     handleAction(api.generateLicense, formData, "License Generated Successfully");
// //     setFormData({ email: '', users: 10, months: 12 });
// //   };

// //   const loadUserDetails = (email) => {
// //       dispatch(fetchUserDetailsRequest(email));
// //       setEditMode(false);
// //   };

// //   const calcMonths = (s, e) => {
// //       const d1=new Date(s), d2=new Date(e);
// //       return Math.max(1, (d2.getFullYear()-d1.getFullYear())*12 - d1.getMonth() + d2.getMonth());
// //   };

// //   const formatBytes = (bytes) => {
// //       if (!bytes || isNaN(bytes)) return '0 B';
// //       const k = 1024;
// //       const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
// //       const i = Math.floor(Math.log(bytes) / Math.log(k));
// //       return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
// //   };

// //   useEffect(() => {
// //       if (adminData.userDetails?.profile) {
// //           setEditedUser({
// //               name: adminData.userDetails.profile.name || '',
// //               email: adminData.userDetails.profile.email || '',
// //               account_type: adminData.userDetails.profile.account_type || 'single',
// //               org_details: adminData.userDetails.profile.org_details || '',
// //               gst_number: adminData.userDetails.profile.gst_number || ''
// //           });
// //       }
// //   }, [adminData.userDetails]);

// //   return (
// //     <div className="max-w-[1400px] mx-auto p-6 text-white pb-20">
// //       <SEO title="Super Admin Console" />

// //       <div className="flex justify-between items-center mb-8">
// //         <h1 className="text-3xl font-bold flex items-center gap-2 text-red-500"><ShieldAlert/> Super Admin Console</h1>
// //         <button onClick={handleLogout} className="flex items-center gap-2 bg-gray-800 px-4 py-2 rounded hover:text-white transition"><LogOut className="w-4 h-4"/> Logout</button>
// //       </div>

// //       <div className="flex gap-4 mb-8 border-b border-gray-800 pb-2 overflow-x-auto whitespace-nowrap">
// //           <button onClick={()=>setActiveTab('live')} className={`pb-2 px-4 font-bold transition flex items-center gap-2 ${activeTab==='live' ? 'text-green-400 border-b-2 border-green-400' : 'text-gray-500 hover:text-white'}`}><Radio className="w-4 h-4"/> Live Network</button>
// //           <button onClick={()=>setActiveTab('overview')} className={`pb-2 px-4 font-bold transition flex items-center gap-2 ${activeTab==='overview' ? 'text-qrypt-primary border-b-2 border-qrypt-primary' : 'text-gray-500 hover:text-white'}`}><Activity className="w-4 h-4"/> Overview</button>
// //           <button onClick={()=>setActiveTab('users')} className={`pb-2 px-4 font-bold transition flex items-center gap-2 ${activeTab==='users' ? 'text-qrypt-primary border-b-2 border-qrypt-primary' : 'text-gray-500 hover:text-white'}`}><Users className="w-4 h-4"/> User Directory</button>
// //           <button onClick={()=>setActiveTab('deleted')} className={`pb-2 px-4 font-bold transition flex items-center gap-2 ${activeTab==='deleted' ? 'text-red-500 border-b-2 border-red-500' : 'text-gray-500 hover:text-white'}`}><Archive className="w-4 h-4"/> Deleted Backups</button>
// //       </div>

// //       {/* --- NEW: LIVE NETWORK TAB --- */}
// //       {activeTab === 'live' && (
// //           <div className="space-y-6">
// //               <div className="bg-gray-900 border border-green-900/50 p-6 rounded-xl flex justify-between items-center shadow-lg shadow-green-900/10">
// //                   <div>
// //                       <h2 className="text-xl font-bold text-green-400 flex items-center gap-2"><Wifi className="w-5 h-5 animate-pulse"/> Active Global Connections</h2>
// //                       <p className="text-gray-400 text-sm mt-1">Real-time telemetry from QryptShield Edge Nodes (Updates every 10s)</p>
// //                   </div>
// //                   <div className="text-right flex items-center gap-4">
// //                       <button onClick={refreshTabContent} className="text-green-400 hover:text-green-300 transition"><RefreshCw className="w-5 h-5"/></button>
// //                       <div>
// //                           <p className="text-4xl font-black text-white">{liveData.active_users}</p>
// //                           <p className="text-xs text-gray-400 uppercase tracking-widest font-bold">Peers Online</p>
// //                       </div>
// //                   </div>
// //               </div>

// //               <div className="bg-gray-900 border border-gray-700 rounded-xl overflow-hidden">
// //                   <table className="w-full text-left text-sm">
// //                       <thead className="bg-gray-800 text-gray-400 uppercase text-xs">
// //                           <tr>
// //                               <th className="p-4">Client Identity</th>
// //                               <th className="p-4">Server Node IP</th>
// //                               <th className="p-4">Client Endpoint IP</th>
// //                               <th className="p-4 text-right">Data Transferred</th>
// //                           </tr>
// //                       </thead>
// //                       <tbody className="divide-y divide-gray-800">
// //                           {liveLoading ? (
// //                               <tr><td colSpan="4" className="p-8 text-center text-gray-500 italic">Syncing with Edge Nodes...</td></tr>
// //                           ) : liveData.connections.length === 0 ? (
// //                               <tr><td colSpan="4" className="p-8 text-center text-gray-500 italic">No active connections found.</td></tr>
// //                           ) : (
// //                               liveData.connections.map((conn, idx) => (
// //                                   <tr key={idx} className="hover:bg-gray-800/50 transition">
// //                                       <td className="p-4 font-medium text-white flex items-center gap-3">
// //                                           <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse"></div>
// //                                           {conn.email}
// //                                       </td>
// //                                       <td className="p-4 font-mono text-xs text-blue-400">{conn.server_ip}</td>
// //                                       <td className="p-4 font-mono text-xs text-gray-400">{conn.client_endpoint}</td>
// //                                       <td className="p-4 text-right font-mono text-xs">
// //                                           <div className="flex items-center justify-end gap-4">
// //                                               <span className="text-orange-400 flex items-center gap-1"><ArrowDownToLine className="w-3 h-3"/> {formatBytes(conn.rx_bytes)}</span>
// //                                               <span className="text-purple-400 flex items-center gap-1"><ArrowUpFromLine className="w-3 h-3"/> {formatBytes(conn.tx_bytes)}</span>
// //                                           </div>
// //                                       </td>
// //                                   </tr>
// //                               ))
// //                           )}
// //                       </tbody>
// //                   </table>
// //               </div>
// //           </div>
// //       )}

// //       {/* --- OVERVIEW TAB --- */}
// //       {activeTab === 'overview' && (
// //           <>
// //             <div className="grid grid-cols-2 gap-6 mb-8">
// //               <div className="bg-gray-800 p-6 rounded-xl border border-gray-700">
// //                   <h3 className="text-gray-400">Total Active Licenses</h3>
// //                   <p className="text-3xl font-bold">{adminData.stats?.total_licenses || 0}</p>
// //               </div>
// //               <div className="bg-gray-800 p-6 rounded-xl border border-gray-700">
// //                   <h3 className="text-gray-400">Total Registered Accounts</h3>
// //                   <p className="text-3xl font-bold">{adminData.stats?.total_users || 0}</p>
// //               </div>
// //             </div>

// //             <div className="grid lg:grid-cols-12 gap-8">
// //               <div className="space-y-6 lg:col-span-5">
// //                   {/* PRICING TIERS */}
// //                   <div className="bg-gray-900 p-5 rounded-xl border border-blue-900/50">
// //                       <h2 className="text-lg font-bold mb-4 flex items-center gap-2 text-blue-500"><IndianRupee/> Pricing Tiers</h2>
// //                       <form onSubmit={(e)=>{e.preventDefault(); handleAction(api.addPricing, pricingData, "Tier Added"); setPricingData({name:'', min_users:1, max_users:10, price:500})}} className="space-y-3 mb-4 pb-4 border-b border-gray-700">
// //                           <input type="text" placeholder="Tier Name" className="w-full bg-gray-800 p-2 rounded text-xs text-white" value={pricingData.name} onChange={(e)=>setPricingData({...pricingData, name: e.target.value})} required/>
// //                           <div className="flex gap-2">
// //                               <input type="number" placeholder="Min" className="w-1/3 bg-gray-800 p-2 rounded text-xs text-white" value={pricingData.min_users} onChange={(e)=>setPricingData({...pricingData, min_users: e.target.value})} />
// //                               <input type="number" placeholder="Max" className="w-1/3 bg-gray-800 p-2 rounded text-xs text-white" value={pricingData.max_users} onChange={(e)=>setPricingData({...pricingData, max_users: e.target.value})} />
// //                               <input type="number" placeholder="₹" className="w-1/3 bg-gray-800 p-2 rounded text-xs text-white" value={pricingData.price} onChange={(e)=>setPricingData({...pricingData, price: e.target.value})} />
// //                           </div>
// //                           <button type="submit" className="w-full bg-blue-600 hover:bg-blue-700 py-1.5 rounded text-xs font-bold">Add Tier</button>
// //                       </form>
// //                       <div className="space-y-2 max-h-[150px] overflow-auto">
// //                           {adminData.pricing.map(t => (
// //                               <div key={t._id} className="bg-gray-800 p-2 rounded flex justify-between">
// //                                   <div><p className="font-bold text-blue-400">{t.name}</p><p className="text-xs text-gray-400">{t.min_users}-{t.max_users} U • ₹{t.price}</p></div>
// //                                   <div className="flex gap-2">
// //                                       <button onClick={() => {let p = prompt('New price:', t.price); if(p) handleAction(api.editPricing, {...t, tier_id: t._id, price: p}, "Price Updated")}} className="text-blue-400"><Edit className="w-3.5 h-3.5"/></button>
// //                                       <button onClick={() => handleAction(api.deletePricing, { tier_id: t._id }, "Delete Tier?")} className="text-red-400"><Trash2 className="w-3.5 h-3.5"/></button>
// //                                   </div>
// //                               </div>
// //                           ))}
// //                       </div>
// //                   </div>

// //                   {/* VPN LOCATIONS */}
// //                   <div className="bg-gray-900 p-5 rounded-xl border border-purple-900/50">
// //                       <h2 className="text-lg font-bold mb-4 flex items-center gap-2 text-purple-500"><MapPin/> VPN Locations</h2>
// //                       <form onSubmit={(e)=>{e.preventDefault(); handleAction(api.addLocation, locationData, "Location Added"); setLocationData({name:'', ip:''})}} className="space-y-3 mb-4 pb-4 border-b border-gray-700">
// //                           <input type="text" placeholder="Region" className="w-full bg-gray-800 p-2 rounded text-xs text-white" value={locationData.name} onChange={(e)=>setLocationData({...locationData, name: e.target.value})} required/>
// //                           <input type="text" placeholder="IP Address" className="w-full bg-gray-800 p-2 rounded text-xs text-white" value={locationData.ip} onChange={(e)=>setLocationData({...locationData, ip: e.target.value})} required/>
// //                           <button type="submit" className="w-full bg-purple-600 hover:bg-purple-700 py-1.5 rounded text-xs font-bold">Add Location</button>
// //                       </form>
// //                       <div className="space-y-2 max-h-[150px] overflow-auto">
// //                           {adminData.locations.map(l => (
// //                               <div key={l._id} className="bg-gray-800 p-2 rounded flex justify-between">
// //                                   <div><p className="font-bold text-purple-400">{l.name}</p><p className="text-xs text-gray-400">{l.ip}</p></div>
// //                                   <button onClick={() => handleAction(api.deleteLocation, { location_id: l._id }, "Delete Location?")} className="text-red-400"><Trash2 className="w-3.5 h-3.5"/></button>
// //                               </div>
// //                           ))}
// //                       </div>
// //                   </div>

// //                   {/* COUPONS */}
// //                   <div className="bg-gray-900 p-5 rounded-xl border border-green-900/50">
// //                       <h2 className="text-lg font-bold mb-4 flex items-center gap-2 text-green-500"><Tag/> Coupons</h2>
// //                       <form onSubmit={(e)=>{e.preventDefault(); handleAction(api.createCoupon, couponData, "Coupon Created"); setCouponData({code:'', discount:10, valid_days:30})}} className="space-y-3 mb-4 pb-4 border-b border-gray-700">
// //                           <div className="flex gap-2">
// //                               <input type="text" placeholder="Code" className="flex-1 bg-gray-800 p-2 rounded text-xs text-white uppercase" value={couponData.code} onChange={(e)=>setCouponData({...couponData, code: e.target.value})} />
// //                               <input type="number" placeholder="%" className="w-16 bg-gray-800 p-2 rounded text-xs text-white" value={couponData.discount} onChange={(e)=>setCouponData({...couponData, discount: e.target.value})} />
// //                           </div>
// //                           <button type="submit" className="w-full bg-green-600 hover:bg-green-700 py-1.5 rounded text-xs font-bold">Add Coupon</button>
// //                       </form>
// //                       <div className="space-y-2 max-h-[150px] overflow-auto">
// //                           {adminData.coupons.map(c => (
// //                               <div key={c.code} className="bg-gray-800 p-2 rounded flex justify-between">
// //                                   <div><p className="font-bold text-green-400">{c.code}</p><p className="text-xs text-gray-400">{c.discount_percent}% Off</p></div>
// //                                   <div className="flex gap-2">
// //                                       <button onClick={() => {let p = prompt('New discount %:', c.discount_percent); if(p) handleAction(api.editCoupon, {code: c.code, new_discount: p}, "Coupon Updated")}} className="text-blue-400"><Edit className="w-3.5 h-3.5"/></button>
// //                                       <button onClick={() => handleAction(api.deleteCoupon, { code: c.code }, "Delete Coupon?")} className="text-red-400"><Trash2 className="w-3.5 h-3.5"/></button>
// //                                   </div>
// //                               </div>
// //                           ))}
// //                       </div>
// //                   </div>

// //                   {/* FORCE GENERATE LICENSE */}
// //                   <div className="bg-gray-900 p-5 rounded-xl border border-red-900/50">
// //                     <h2 className="text-lg font-bold mb-4 flex items-center gap-2 text-red-500"><Plus/> Force Generate License</h2>
// //                     <form onSubmit={handleGenerate} className="space-y-3">
// //                       <input type="email" placeholder="Client Email" className="w-full bg-gray-800 p-2 rounded text-xs text-white" value={formData.email} onChange={(e)=>setFormData({...formData, email: e.target.value})} required />
// //                       <div className="flex gap-2">
// //                           <input type="number" placeholder="Users" className="w-1/2 bg-gray-800 p-2 rounded text-xs text-white" value={formData.users} onChange={(e)=>setFormData({...formData, users: parseInt(e.target.value)})} />
// //                           <input type="number" placeholder="Months" className="w-1/2 bg-gray-800 p-2 rounded text-xs text-white" value={formData.months} onChange={(e)=>setFormData({...formData, months: parseInt(e.target.value)})} />
// //                       </div>
// //                       <button type="submit" className="w-full bg-red-600 hover:bg-red-700 py-2 rounded text-sm font-bold mt-2">Generate Free Key</button>
// //                     </form>
// //                   </div>
// //               </div>

// //               {/* RECENT LICENSES LIST */}
// //               <div className="bg-gray-900 p-6 rounded-xl border border-gray-700 h-fit lg:col-span-7">
// //                 <h2 className="text-xl font-bold mb-4 flex justify-between">Recent Licenses <button onClick={refreshTabContent} className="hover:text-blue-400 transition"><RefreshCw className="w-5 h-5"/></button></h2>
// //                 <div className="overflow-auto max-h-[1000px]">
// //                   <table className="w-full text-left text-sm whitespace-nowrap">
// //                     <thead className="text-gray-500 uppercase bg-gray-800 sticky top-0 z-10">
// //                       <tr><th className="p-3">Info</th><th className="p-3">Plan</th><th className="p-3">Status</th><th className="p-3 text-right">Actions</th></tr>
// //                     </thead>
// //                     <tbody className="divide-y divide-gray-800">
// //                       {adminData.licenses.map(lic => (
// //                         <React.Fragment key={lic._id}>
// //                           <tr className={`hover:bg-gray-800/50 transition ${lic.status==='banned' ? 'bg-red-900/20 opacity-75' : ''}`}>
// //                             <td className="p-3"><div className="font-medium text-white">{lic.purchaser_email}</div><div className="font-mono text-yellow-500 text-xs mt-1">{lic.license_key}</div></td>
// //                             <td className="p-3"><div className="font-bold text-white">{lic.max_users} Users</div><div className="text-xs text-gray-400">{calcMonths(lic.start_date, lic.expiry_date)} Mo</div></td>
// //                             <td className="p-3"><span className={`text-[10px] px-2 py-1 rounded border uppercase font-bold ${lic.status === 'active' ? 'border-green-500 text-green-500' : 'border-red-500 text-red-500'}`}>{lic.status}</span></td>
// //                             <td className="p-3 text-right flex justify-end gap-2 mt-2">
// //                                 <button onClick={() => setExpandedLicense(expandedLicense === lic.license_key ? null : lic.license_key)} className={`p-2 transition rounded ${expandedLicense === lic.license_key ? 'bg-qrypt-primary text-white' : 'border border-gray-600 text-gray-400 hover:text-white'}`}><Users className="w-4 h-4"/></button>
// //                                 {lic.status !== 'banned' && (
// //                                     <button onClick={()=>handleAction(api.updateLicenseStatus, {license_key: lic.license_key, status: lic.status==='active'?'suspended':'active'}, "Status Updated")} className="p-2 transition rounded hover:bg-gray-700">{lic.status === 'active' ? <Pause className="w-4 h-4 text-orange-400"/> : <Play className="w-4 h-4 text-green-400"/>}</button>
// //                                 )}
// //                                 <button onClick={()=>handleToggleBan(lic.purchaser_email, lic.status === 'banned')} className="p-2 transition rounded hover:bg-gray-700">{lic.status === 'banned' ? <CheckCircle className="w-4 h-4 text-blue-400"/> : <Ban className="w-4 h-4 text-red-500"/>}</button>
// //                             </td>
// //                           </tr>
// //                           {expandedLicense === lic.license_key && (
// //                             <tr className="bg-gray-800 border-b-2 border-qrypt-primary shadow-inner">
// //                               <td colSpan="4" className="p-4">
// //                                   <div className="flex justify-between items-center mb-3">
// //                                       <h4 className="font-bold text-gray-200">Authorized Users</h4>
// //                                       <button onClick={() => {let e=prompt("Email:"); if(e) handleAction(api.adminAddEmployee, {license_key: lic.license_key, employee_email: e}, "User Added")}} className="text-xs bg-qrypt-primary hover:bg-blue-600 transition px-3 py-1 rounded text-white font-bold">+ Add</button>
// //                                   </div>
// //                                   <div className="grid grid-cols-2 gap-2">
// //                                       {lic.valid_emails?.length > 0 ? lic.valid_emails.map(emp => {
// //                                           const isOwner = emp === lic.purchaser_email;
// //                                           return (
// //                                             <div key={emp} className="flex justify-between items-center bg-gray-900 border border-gray-700 p-2 rounded text-xs text-gray-300">
// //                                                 <span className="truncate flex items-center gap-2">
// //                                                     {emp}
// //                                                     {isOwner && (
// //                                                         <span className="text-[9px] bg-qrypt-primary text-white px-1.5 py-0.5 rounded uppercase font-bold">Owner</span>
// //                                                     )}
// //                                                 </span>
// //                                                 <div className="flex gap-2 ml-2">
// //                                                     {!isOwner && (
// //                                                         <>
// //                                                             <button onClick={() => {let e=prompt('New email:', emp); if(e && e!==emp) handleAction(api.adminEditEmployee, {license_key: lic.license_key, old_email: emp, new_email: e}, "Email Updated")}} className="text-blue-400 hover:text-white transition"><Edit className="w-3.5 h-3.5"/></button>
// //                                                             <button onClick={()=>handleAction(api.adminRemoveEmployee, {license_key: lic.license_key, employee_email: emp}, "Remove User?")} className="text-red-400 hover:text-white transition"><Trash2 className="w-3.5 h-3.5"/></button>
// //                                                         </>
// //                                                     )}
// //                                                 </div>
// //                                             </div>
// //                                           )
// //                                       }) : <span className="text-xs text-gray-500 italic">No users attached.</span>}
// //                                   </div>
// //                               </td>
// //                             </tr>
// //                           )}
// //                         </React.Fragment>
// //                       ))}
// //                     </tbody>
// //                   </table>
// //                 </div>
// //               </div>
// //             </div>
// //           </>
// //       )}

// //       {/* --- USERS & DELETED TABS --- */}
// //       {(activeTab === 'users' || activeTab === 'deleted') && (
// //           <div className="grid lg:grid-cols-12 gap-8">
// //               {/* USER DIRECTORY LIST */}
// //               <div className="lg:col-span-4 bg-gray-900 p-6 rounded-xl border border-gray-700 h-fit max-h-[800px] overflow-auto">
// //                   <h2 className="text-xl font-bold mb-4 flex items-center gap-2"><Search className="w-5 h-5 text-gray-400"/> Directory</h2>
// //                   <div className="space-y-2">
// //                       {(activeTab === 'users' ? adminData.usersList : adminData.deletedList).map(u => (
// //                           <div key={u._id} onClick={() => loadUserDetails(u.email)} className={`p-4 rounded-lg cursor-pointer transition border ${adminData.userDetails?.profile?.email === u.email ? 'bg-qrypt-primary/20 border-qrypt-primary' : 'bg-gray-800 border-gray-700 hover:bg-gray-700'}`}>
// //                               <div className="flex justify-between items-center">
// //                                   <div><p className="font-bold text-sm">{u.name || 'No Name'}</p><p className="text-xs text-gray-400">{u.email}</p></div>
// //                                   <span className={`text-[10px] px-2 py-1 rounded uppercase font-bold border ${activeTab === 'deleted' || u.is_banned ? 'border-red-500 text-red-500' : 'border-green-500 text-green-500'}`}>
// //                                       {activeTab === 'deleted' ? 'DELETED' : (u.is_banned ? 'BANNED' : 'ACTIVE')}
// //                                   </span>
// //                               </div>
// //                           </div>
// //                       ))}
// //                   </div>
// //               </div>

// //               {/* USER DETAILS PANEL */}
// //               <div className="lg:col-span-8">
// //                   {adminData.detailsLoading ? <div className="text-center p-10 bg-gray-900 rounded-xl text-gray-400">Loading...</div> :
// //                   !adminData.userDetails ? <div className="text-center p-10 bg-gray-900 border border-gray-700 rounded-xl text-gray-500">Select an account from the list.</div> :
// //                   (
// //                       <div className="space-y-6">
// //                           <div className="bg-gray-900 p-6 rounded-xl border border-gray-700 shadow-xl">
// //                               <div className="flex justify-between items-center border-b border-gray-800 pb-4 mb-4">
// //                                   <h2 className="text-xl font-bold flex items-center gap-2">User Profile</h2>
// //                                   <div className="flex gap-2">
// //                                       {activeTab !== 'deleted' && (
// //                                         <button onClick={() => handleToggleBan(adminData.userDetails.profile.email, adminData.userDetails.profile.is_banned)} className={`px-4 py-1.5 rounded text-sm font-bold flex items-center gap-2 ${adminData.userDetails.profile.is_banned ? 'bg-green-600 hover:bg-green-500' : 'bg-orange-600 hover:bg-orange-500'}`}>
// //                                             {adminData.userDetails.profile.is_banned ? <><CheckCircle className="w-4 h-4"/> Unban Account</> : <><Ban className="w-4 h-4"/> Suspend Account</>}
// //                                         </button>
// //                                       )}
// //                                       {!editMode ? (
// //                                           <button onClick={()=>setEditMode(true)} className="bg-blue-600 hover:bg-blue-500 px-4 py-1.5 rounded text-sm font-bold flex items-center gap-2"><Edit className="w-4 h-4"/> Edit Profile</button>
// //                                       ) : (
// //                                           <button onClick={()=>setEditMode(false)} className="bg-gray-600 hover:bg-gray-500 px-4 py-1.5 rounded text-sm font-bold">Cancel</button>
// //                                       )}
// //                                       {activeTab !== 'deleted' && <button onClick={()=>handleDeleteUser(adminData.userDetails.profile.email)} className="bg-red-600 hover:bg-red-500 px-4 py-1.5 rounded text-sm font-bold flex items-center gap-2"><Trash2 className="w-4 h-4"/> Delete</button>}
// //                                   </div>
// //                               </div>
// //                               {!editMode ? (
// //                                   <div className="grid grid-cols-2 gap-4 text-sm">
// //                                       <div><p className="text-gray-500">Name</p><p className="font-bold text-lg">{adminData.userDetails.profile.name}</p></div>
// //                                       <div><p className="text-gray-500">Email</p><p className="font-bold">{adminData.userDetails.profile.email}</p></div>
// //                                       <div><p className="text-gray-500">Account Type</p><p className="font-bold capitalize">{adminData.userDetails.profile.account_type}</p></div>
// //                                       {adminData.userDetails.profile.account_type === 'organisation' && (
// //                                           <>
// //                                               <div><p className="text-gray-500">Org Name</p><p className="font-bold">{adminData.userDetails.profile.org_details}</p></div>
// //                                               <div><p className="text-gray-500">GST Number</p><p className="font-bold uppercase">{adminData.userDetails.profile.gst_number || 'N/A'}</p></div>
// //                                           </>
// //                                       )}
// //                                   </div>
// //                               ) : (
// //                                   <form onSubmit={handleUpdateUser} className="space-y-4">
// //                                       <input type="text" className="w-full bg-gray-800 p-2 rounded outline-none text-white border border-gray-700" value={editedUser.name} onChange={(e)=>setEditedUser({...editedUser, name: e.target.value})} required placeholder="Full Name"/>
// //                                       <select className="w-full bg-gray-800 p-2 rounded outline-none text-white border border-gray-700" value={editedUser.account_type} onChange={(e)=>setEditedUser({...editedUser, account_type: e.target.value})}>
// //                                           <option value="single">Single User</option><option value="organisation">Organisation</option>
// //                                       </select>
// //                                       {editedUser.account_type === 'organisation' && (
// //                                           <>
// //                                               <input type="text" className="w-full bg-gray-800 p-2 rounded outline-none text-white border border-gray-700" value={editedUser.org_details} onChange={(e)=>setEditedUser({...editedUser, org_details: e.target.value})} placeholder="Org Name" required/>
// //                                               <input type="text" className="w-full bg-gray-800 p-2 rounded outline-none text-white uppercase border border-gray-700" value={editedUser.gst_number} onChange={(e)=>setEditedUser({...editedUser, gst_number: e.target.value})} placeholder="GST"/>
// //                                           </>
// //                                       )}
// //                                       <button type="submit" className="bg-green-600 hover:bg-green-500 px-6 py-2 rounded font-bold w-full">Save Changes</button>
// //                                   </form>
// //                               )}
// //                           </div>

// //                           <h3 className="text-lg font-bold text-gray-400 mt-6 flex items-center gap-2"><Activity className="w-5 h-5"/> Account Activity & Licenses</h3>
// //                           {adminData.userDetails.licenses.map(lic => (
// //                               <div key={lic.license_key} className="bg-gray-800 p-6 rounded-xl border border-gray-700">
// //                                   <div className="flex justify-between items-start border-b border-gray-700 pb-4 mb-4">
// //                                       <div><p className="font-mono text-yellow-500 text-lg">{lic.license_key}</p><p className="text-sm text-gray-400 mt-1">Capacity: {lic.valid_emails?.length||0} / {lic.max_users} Users</p></div>
// //                                       <span className={`text-[10px] px-2 py-1 rounded uppercase font-bold border ${lic.status === 'active' ? 'border-green-500 text-green-500' : 'border-red-500 text-red-500'}`}>{lic.status}</span>
// //                                   </div>
// //                                   {lic.valid_emails?.length > 0 ? (
// //                                       <div className="flex flex-wrap gap-2">
// //                                           {lic.valid_emails.map(e => {
// //                                               const isOwner = e === lic.purchaser_email;
// //                                               return (
// //                                                   <span key={e} className="bg-gray-900 px-3 py-1 rounded text-xs border border-gray-700 flex items-center gap-2">
// //                                                       {e}
// //                                                       {isOwner && <span className="text-[9px] bg-qrypt-primary text-white px-1.5 py-0.5 rounded uppercase font-bold">Owner</span>}
// //                                                   </span>
// //                                               )
// //                                           })}
// //                                       </div>
// //                                   ) : <p className="text-xs text-gray-500 italic">No employees connected.</p>}
// //                               </div>
// //                           ))}
// //                           {adminData.userDetails.licenses.length === 0 && <p className="text-gray-500 italic bg-gray-900 p-4 rounded text-center border border-dashed border-gray-700">No purchase history found for this account.</p>}
// //                       </div>
// //                   )}
// //               </div>
// //           </div>
// //       )}
// //     </div>
// //   );
// // };

// // export default Admin;

// change code 25/02/2026
// change code 25/02/2026

import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../redux/slices/authSlice";
import {
  fetchOverviewRequest,
  fetchUsersRequest,
  fetchDeletedRequest,
  fetchUserDetailsRequest,
  adminActionRequest,
} from "../redux/slices/adminSlice";
import * as api from "../api";
import SEO from "../components/SEO";
import {
  ShieldAlert,
  Plus,
  RefreshCw,
  Tag,
  Ban,
  Trash2,
  Edit,
  LogOut,
  Play,
  Pause,
  CheckCircle,
  Users,
  IndianRupee,
  MapPin,
  Activity,
  Archive,
  Search,
  Radio,
  Wifi,
  MoreVertical,
  ArrowDownToLine,
  ArrowUpFromLine,
} from "lucide-react";

const Admin = () => {
  const [activeTab, setActiveTab] = useState("overview");
  const [expandedLicense, setExpandedLicense] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // Live Network State
  const [liveData, setLiveData] = useState({
    active_users: 0,
    connections: [],
  });
  const [liveLoading, setLiveLoading] = useState(false);

  // Local states for Forms
  const [formData, setFormData] = useState({
    email: "",
    users: 10,
    months: 12,
  });
  const [couponData, setCouponData] = useState({
    code: "",
    discount: 10,
    valid_days: 30,
  });
  const [pricingData, setPricingData] = useState({
    name: "",
    min_users: 1,
    max_users: 9,
    price: 500,
  });
  const [locationData, setLocationData] = useState({ name: "", ip: "" });
  const [editMode, setEditMode] = useState(false);
  const [editedUser, setEditedUser] = useState({
    name: "",
    email: "",
    account_type: "single",
    org_details: "",
    gst_number: "",
  });

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { token } = useSelector((state) => state.auth);
  const adminData = useSelector((state) => state.admin);
  const stats = adminData.stats || {};
  const licenseList = adminData.licenses || [];
  const pricingTiers = adminData.pricing || [];
  const locationList = adminData.locations || [];
  const couponList = adminData.coupons || [];
  const sectionBackground =
    "bg-gradient-to-br from-[#08101e] via-[#05060d] to-[#020308] border border-white/5 rounded-3xl shadow-[0_20px_80px_rgba(2,6,23,0.6)] p-6";

  // --- Helpers ---
  const fetchLiveConnections = useCallback(async (showLoading = false) => {
    try {
      if (showLoading) setLiveLoading(true);
      const res = await api.getLiveConnections();
      setLiveData(res.data);
    } catch (err) {
      console.error("Failed to fetch live connections", err);
    } finally {
      setLiveLoading(false);
    }
  }, []);

  const refreshTabContent = useCallback(() => {
    if (activeTab === "overview") dispatch(fetchOverviewRequest());
    else if (activeTab === "users") dispatch(fetchUsersRequest());
    else if (activeTab === "deleted") dispatch(fetchDeletedRequest());
    else if (activeTab === "live") fetchLiveConnections(true);
  }, [activeTab, dispatch, fetchLiveConnections]);

  useEffect(() => {
    if (!token) navigate("/login");
    else refreshTabContent();
  }, [token, navigate, refreshTabContent]);

  useEffect(() => {
    let interval;
    if (activeTab === "live")
      interval = setInterval(() => fetchLiveConnections(false), 10000);
    return () => clearInterval(interval);
  }, [activeTab, fetchLiveConnections]);

  useEffect(() => {
    if (adminData.userDetails?.profile) {
      setEditedUser({
        name: adminData.userDetails.profile.name || "",
        email: adminData.userDetails.profile.email || "",
        account_type: adminData.userDetails.profile.account_type || "single",
        org_details: adminData.userDetails.profile.org_details || "",
        gst_number: adminData.userDetails.profile.gst_number || "",
      });
    }
  }, [adminData.userDetails]);

  const handleLogout = () => {
    dispatch(logout());
    navigate("/login");
  };

  const handleAction = (
    apiCall,
    params,
    successMsg,
    emailForRefresh = null,
  ) => {
    dispatch(
      adminActionRequest({
        apiCall,
        params,
        successMsg,
        refreshAction:
          activeTab === "overview"
            ? fetchOverviewRequest
            : activeTab === "users"
              ? fetchUsersRequest
              : fetchDeletedRequest,
        emailForDetailsRefresh: emailForRefresh,
      }),
    );
  };

  const handleUpdateUser = (e) => {
    e.preventDefault();
    handleAction(
      (uData) => api.adminUpdateUser(uData.email, uData),
      editedUser,
      "User Profile Updated",
      editedUser.email,
    );
    setEditMode(false);
  };

  const handleToggleBan = (email, isBanned) => {
    if (!window.confirm(`${isBanned ? "Unban" : "Suspend"} this account?`))
      return;
    handleAction(api.toggleBanUser, { email }, "Account Status Updated", email);
  };

  const handleDeleteUser = (email) => {
    if (
      !window.confirm(
        "Hard delete and move to backups? This action is permanent.",
      )
    )
      return;
    handleAction(api.adminDeleteUser, email, "Account Deleted & Backed Up");
  };

  const handleGenerate = (e) => {
    e.preventDefault();
    if (!window.confirm(`Generate FREE license for ${formData.email}?`)) return;
    handleAction(
      api.generateLicense,
      formData,
      "License Generated Successfully",
    );
    setFormData({ email: "", users: 10, months: 12 });
  };

  const loadUserDetails = (email) => {
    dispatch(fetchUserDetailsRequest(email));
    setEditMode(false);
  };

  const calcMonths = (s, e) => {
    const d1 = new Date(s),
      d2 = new Date(e);
    return Math.max(
      1,
      (d2.getFullYear() - d1.getFullYear()) * 12 -
        d1.getMonth() +
        d2.getMonth(),
    );
  };

  const formatBytes = (bytes) => {
    if (!bytes || isNaN(bytes)) return "0 B";
    const k = 1024;
    const sizes = ["B", "KB", "MB", "GB", "TB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(2))} ${sizes[i]}`;
  };

  return (
    <div className="relative min-h-screen bg-[#050910] text-white">
      <SEO title="Super Admin Console" />

      <div className="fixed inset-0 z-0 pointer-events-none">
        <div
          className="absolute inset-0 opacity-[0.08]"
          style={{
            backgroundImage: `linear-gradient(to right, #ffffff60 1px, transparent 1px), linear-gradient(to bottom, #ffffff60 1px, transparent 1px)`,
            backgroundSize: "40px 40px",
          }}
        />
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-red-600/10 rounded-full blur-[120px]" />
      </div>

      <div className="relative z-10 flex">
        <aside
          className={`fixed inset-y-0 left-0 w-72 bg-black/60 backdrop-blur-xl border-r border-white/10 transform transition-transform duration-300 md:translate-x-0 ${sidebarOpen ? "translate-x-0" : "-translate-x-full"} md:static md:w-72`}
        >
          <div className="flex items-center justify-between px-5 py-4 border-b border-white/5">
            <div className="flex items-center gap-2">
              <img src="logo.png" alt="logo" className="h-8 w-auto" />
              <div>
                <p className="font-bold">QryptShield</p>
                <p className="text-xs text-gray-400 uppercase">Super Admin</p>
              </div>
            </div>
            <button
              className="md:hidden text-gray-400 hover:text-white"
              onClick={() => setSidebarOpen(false)}
            >
              ✕
            </button>
          </div>

          <nav className="px-4 py-5 space-y-2">
            {[
              { key: "live", label: "Live Network", icon: Radio },
              { key: "overview", label: "Overview", icon: Activity },
              { key: "users", label: "User Directory", icon: Users },
              { key: "deleted", label: "Deleted Backups", icon: Archive },
            ].map((item) => {
              const Icon = item.icon;
              const active = activeTab === item.key;
              return (
                <button
                  key={item.key}
                  onClick={() => {
                    setActiveTab(item.key);
                    setSidebarOpen(false);
                    refreshTabContent();
                  }}
                  className={`w-full flex items-center gap-3 px-3 py-3 rounded-xl text-sm font-semibold border transition ${active ? "bg-red-600 text-white border-red-500" : "bg-white/5 text-gray-300 border-white/10 hover:bg-white/10"}`}
                >
                  <Icon className="w-4 h-4" />
                  {item.label}
                </button>
              );
            })}

            <div className="mt-6 space-y-3 rounded-2xl bg-white/5 border border-white/10 p-4">
              <div className="flex items-center justify-between">
                <span className="text-xs text-gray-400 uppercase tracking-wider">
                  Summary
                </span>
                <button
                  onClick={refreshTabContent}
                  className="text-xs text-blue-300 hover:text-blue-200"
                >
                  Refresh
                </button>
              </div>
              <p className="text-sm text-white font-semibold">
                Licenses: {adminData.stats?.total_licenses || 0}
              </p>
              <p className="text-sm text-gray-300">
                Accounts: {adminData.stats?.total_users || 0}
              </p>
              <p className="text-sm text-gray-300">
                Coupons: {adminData.coupons?.length || 0}
              </p>
            </div>
          </nav>
        </aside>

        <div className="flex-1 min-h-screen min-w-0">
          <header className="sticky top-0 z-20 bg-[#050910]/80 backdrop-blur-xl border-b border-white/10 px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between">
            <div className="flex items-center gap-3">
              <button
                className="md:hidden px-3 py-2 rounded-lg border border-white/10 text-gray-200"
                onClick={() => setSidebarOpen(!sidebarOpen)}
              >
                ☰
              </button>
              <div>
                <p className="text-sm text-gray-400">Admin Console</p>
                <p className="font-semibold text-white">Secure Operations</p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <button
                onClick={refreshTabContent}
                className="hidden sm:inline-flex items-center gap-2 px-3 py-2 rounded-lg border border-white/10 bg-white/5 hover:bg-white/10 text-sm"
              >
                <RefreshCw className="w-4 h-4" />
                Sync
              </button>
              <button
                onClick={handleLogout}
                className="inline-flex items-center gap-2 px-4 py-2 rounded-lg border border-white/10 bg-white/5 hover:bg-white/10 transition"
              >
                <LogOut className="w-4 h-4" />
                Logout
              </button>
            </div>
          </header>

          <main className="w-full px-4 sm:px-6 lg:px-8 xl:px-10 pt-6 pb-16 space-y-8">
            {activeTab === "live" && (
              <div className="space-y-6">
                <div className="bg-gray-900 border border-green-900/50 p-6 rounded-xl flex flex-col md:flex-row md:items-center md:justify-between gap-4 shadow-lg shadow-green-900/10">
                  <div>
                    <h2 className="text-xl font-bold text-green-400 flex items-center gap-2">
                      <Wifi className="w-5 h-5 animate-pulse" /> Active Global
                      Connections
                    </h2>
                    <p className="text-gray-400 text-sm mt-1">
                      Real-time telemetry from QryptShield Edge Nodes (updates
                      every 10s)
                    </p>
                  </div>
                  <div className="flex items-center gap-4">
                    <button
                      onClick={refreshTabContent}
                      className="text-green-400 hover:text-green-300 transition"
                    >
                      <RefreshCw className="w-5 h-5" />
                    </button>
                    <div className="text-right">
                      <p className="text-4xl font-black text-white">
                        {liveData.active_users}
                      </p>
                      <p className="text-xs text-gray-400 uppercase tracking-widest font-bold">
                        Peers Online
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-gray-900 border border-gray-700 rounded-xl overflow-hidden">
                  <div className="overflow-auto">
                    <table className="w-full text-left text-sm min-w-[700px]">
                      <thead className="bg-gray-800 text-gray-400 uppercase text-xs">
                        <tr>
                          <th className="p-4">Client Identity</th>
                          <th className="p-4">Server Node IP</th>
                          <th className="p-4">Client Endpoint IP</th>
                          <th className="p-4 text-right">Data Transferred</th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-gray-800">
                        {liveLoading ? (
                          <tr>
                            <td
                              colSpan="4"
                              className="p-8 text-center text-gray-500 italic"
                            >
                              Syncing with Edge Nodes...
                            </td>
                          </tr>
                        ) : liveData.connections.length === 0 ? (
                          <tr>
                            <td
                              colSpan="4"
                              className="p-8 text-center text-gray-500 italic"
                            >
                              No active connections found.
                            </td>
                          </tr>
                        ) : (
                          liveData.connections.map((conn, idx) => (
                            <tr
                              key={idx}
                              className="hover:bg-gray-800/50 transition"
                            >
                              <td className="p-4 font-medium text-white flex items-center gap-3">
                                <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse"></div>
                                {conn.email}
                              </td>
                              <td className="p-4 font-mono text-xs text-blue-400">
                                {conn.server_ip}
                              </td>
                              <td className="p-4 font-mono text-xs text-gray-400">
                                {conn.client_endpoint}
                              </td>
                              <td className="p-4 text-right font-mono text-xs">
                                <div className="flex items-center justify-end gap-4">
                                  <span className="text-orange-400 flex items-center gap-1">
                                    <ArrowDownToLine className="w-3 h-3" />{" "}
                                    {formatBytes(conn.rx_bytes)}
                                  </span>
                                  <span className="text-purple-400 flex items-center gap-1">
                                    <ArrowUpFromLine className="w-3 h-3" />{" "}
                                    {formatBytes(conn.tx_bytes)}
                                  </span>
                                </div>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}

            {activeTab === "overview" && (
              <div className="space-y-8">
                <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
                  <div className="bg-gradient-to-br from-slate-900 via-slate-950 to-slate-900 border border-white/10 rounded-3xl shadow-xl p-6">
                    <p className="text-xs uppercase tracking-[0.3em] text-gray-400 mb-3">
                      Active Licenses
                    </p>
                    <p className="text-4xl font-black text-white">
                      {stats.total_licenses || 0}
                    </p>
                    <p className="text-sm text-gray-400 mt-2">
                      Synced with live telemetry
                    </p>
                  </div>
                  <div className="bg-gradient-to-br from-slate-900 via-slate-950 to-slate-900 border border-white/10 rounded-3xl shadow-xl p-6">
                    <p className="text-xs uppercase tracking-[0.3em] text-gray-400 mb-3">
                      Registered Accounts
                    </p>
                    <p className="text-4xl font-black text-white">
                      {stats.total_users || 0}
                    </p>
                    <p className="text-sm text-gray-400 mt-2">
                      Across all tiers
                    </p>
                  </div>
                  <div className="bg-gradient-to-br from-slate-900 via-slate-950 to-slate-900 border border-white/10 rounded-3xl shadow-xl p-6">
                    <p className="text-xs uppercase tracking-[0.3em] text-gray-400 mb-3">
                      Coupon Library
                    </p>
                    <p className="text-4xl font-black text-white">
                      {couponList.length}
                    </p>
                    <p className="text-sm text-gray-400 mt-2">
                      Incentives ready to deploy
                    </p>
                  </div>
                </div>

                {/* ── Row 1: Controls + Recent Licenses ── */}
                <div className="grid gap-6 lg:grid-cols-2 items-stretch">
                  {/* LEFT – Pricing + Locations */}
                  <div className="grid gap-6 content-start">
                    <section className={`${sectionBackground} space-y-4`}>
                      <div className="flex items-center justify-between">
                        <div className="flex items-center gap-2">
                          <IndianRupee className="w-5 h-5 text-blue-400" />
                          <p className="text-sm font-semibold uppercase tracking-wider text-white">
                            Pricing Tiers
                          </p>
                        </div>
                        <div className="flex items-center gap-2">
                          <span className="text-xs text-gray-400 uppercase tracking-[0.3em]">
                            {pricingTiers.length} tiers
                          </span>
                          <button
                            className="p-1.5 rounded-lg hover:bg-white/10 text-gray-400"
                            aria-label="Pricing menu"
                          >
                            <MoreVertical className="w-4 h-4" />
                          </button>
                        </div>
                      </div>
                      <form
                        onSubmit={(e) => {
                          e.preventDefault();
                          handleAction(
                            api.addPricing,
                            pricingData,
                            "Tier Added",
                          );
                          setPricingData({
                            name: "",
                            min_users: 1,
                            max_users: 10,
                            price: 500,
                          });
                        }}
                        className="space-y-3"
                      >
                        <input
                          type="text"
                          placeholder="Tier Name"
                          className="w-full bg-white/5 border border-white/10 rounded-2xl px-3 py-2 text-sm text-white placeholder:text-gray-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
                          value={pricingData.name}
                          onChange={(e) =>
                            setPricingData({
                              ...pricingData,
                              name: e.target.value,
                            })
                          }
                          required
                        />
                        <div className="grid grid-cols-3 gap-3">
                          <input
                            type="number"
                            placeholder="Min Users"
                            className="bg-white/5 border border-white/10 rounded-2xl px-3 py-2 text-sm text-white"
                            value={pricingData.min_users}
                            onChange={(e) =>
                              setPricingData({
                                ...pricingData,
                                min_users: e.target.value,
                              })
                            }
                          />
                          <input
                            type="number"
                            placeholder="Max Users"
                            className="bg-white/5 border border-white/10 rounded-2xl px-3 py-2 text-sm text-white"
                            value={pricingData.max_users}
                            onChange={(e) =>
                              setPricingData({
                                ...pricingData,
                                max_users: e.target.value,
                              })
                            }
                          />
                          <input
                            type="number"
                            placeholder="Price ₹"
                            className="bg-white/5 border border-white/10 rounded-2xl px-3 py-2 text-sm text-white"
                            value={pricingData.price}
                            onChange={(e) =>
                              setPricingData({
                                ...pricingData,
                                price: e.target.value,
                              })
                            }
                          />
                        </div>
                        <button
                          type="submit"
                          className="w-full bg-blue-600 hover:bg-blue-700 text-xs font-bold uppercase tracking-[0.3em] py-2 rounded-2xl"
                        >
                          Add tier
                        </button>
                      </form>
                      <div className="space-y-2 max-h-[180px] overflow-y-auto pr-1">
                        {pricingTiers.length === 0 ? (
                          <p className="text-xs italic text-gray-500">
                            No tiers configured yet.
                          </p>
                        ) : (
                          pricingTiers.map((t) => (
                            <div
                              key={t._id}
                              className="bg-white/5 border border-white/5 rounded-2xl p-3 grid grid-cols-[1fr_auto] items-center gap-3 text-sm"
                            >
                              <div>
                                <p className="font-semibold text-white">
                                  {t.name}
                                </p>
                                <p className="text-xs text-gray-400">
                                  {t.min_users}-{t.max_users} Users • ₹{t.price}
                                </p>
                              </div>
                              <div className="flex items-center gap-2 text-sm">
                                <button
                                  onClick={() => {
                                    const p = prompt("New price:", t.price);
                                    if (p)
                                      handleAction(
                                        api.editPricing,
                                        { ...t, tier_id: t._id, price: p },
                                        "Price Updated",
                                      );
                                  }}
                                  className="text-blue-400"
                                >
                                  <Edit className="w-3.5 h-3.5" />
                                </button>
                                <button
                                  onClick={() =>
                                    handleAction(
                                      api.deletePricing,
                                      { tier_id: t._id },
                                      "Pricing Deleted",
                                    )
                                  }
                                  className="text-red-400"
                                >
                                  <Trash2 className="w-3.5 h-3.5" />
                                </button>
                              </div>
                            </div>
                          ))
                        )}
                      </div>
                    </section>

                    <section className={`${sectionBackground} space-y-4`}>
                      <div className="flex items-center justify-between">
                        <div className="flex items-center gap-2">
                          <MapPin className="w-5 h-5 text-purple-400" />
                          <p className="text-sm font-semibold uppercase tracking-wider text-white">
                            VPN Locations
                          </p>
                        </div>
                        <button
                          className="p-1.5 rounded-lg hover:bg-white/10 text-gray-400"
                          aria-label="Locations menu"
                        >
                          <MoreVertical className="w-4 h-4" />
                        </button>
                      </div>
                      <form
                        onSubmit={(e) => {
                          e.preventDefault();
                          handleAction(
                            api.addLocation,
                            locationData,
                            "Location Added",
                          );
                          setLocationData({ name: "", ip: "" });
                        }}
                        className="space-y-3"
                      >
                        <input
                          type="text"
                          placeholder="Region"
                          className="w-full bg-white/5 border border-white/10 rounded-2xl px-3 py-2 text-sm text-white placeholder:text-gray-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
                          value={locationData.name}
                          onChange={(e) =>
                            setLocationData({
                              ...locationData,
                              name: e.target.value,
                            })
                          }
                          required
                        />
                        <input
                          type="text"
                          placeholder="IP Address"
                          className="w-full bg-white/5 border border-white/10 rounded-2xl px-3 py-2 text-sm text-white placeholder:text-gray-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
                          value={locationData.ip}
                          onChange={(e) =>
                            setLocationData({
                              ...locationData,
                              ip: e.target.value,
                            })
                          }
                          required
                        />
                        <button
                          type="submit"
                          className="w-full bg-purple-600 hover:bg-purple-700 text-xs font-bold uppercase tracking-[0.3em] py-2 rounded-2xl"
                        >
                          Add Location
                        </button>
                      </form>
                      <div className="space-y-2 max-h-[150px] overflow-auto pr-1">
                        {locationList.length === 0 ? (
                          <p className="text-xs italic text-gray-500">
                            No locations configured yet.
                          </p>
                        ) : (
                          locationList.map((l) => (
                            <div
                              key={l._id}
                              className="bg-white/5 border border-white/5 rounded-2xl p-3 flex justify-between items-center"
                            >
                              <div>
                                <p className="font-semibold text-white">
                                  {l.name}
                                </p>
                                <p className="text-xs text-gray-400">{l.ip}</p>
                              </div>
                              <button
                                onClick={() =>
                                  handleAction(
                                    api.deleteLocation,
                                    { location_id: l._id },
                                    "Location Deleted",
                                  )
                                }
                                className="text-red-400"
                              >
                                <Trash2 className="w-3.5 h-3.5" />
                              </button>
                            </div>
                          ))
                        )}
                      </div>
                    </section>
                  </div>

                  {/* RIGHT – Recent Licenses */}
                  <div
                    className={`${sectionBackground} flex flex-col min-h-[420px]`}
                  >
                    <div className="flex items-center justify-between mb-4">
                      <h2 className="text-xl font-bold">Recent Licenses</h2>
                      <div className="flex items-center gap-2">
                        <button
                          onClick={refreshTabContent}
                          className="p-2 rounded-lg hover:bg-white/10 transition"
                        >
                          <RefreshCw className="w-5 h-5" />
                        </button>
                        <button
                          className="p-2 rounded-lg hover:bg-white/10 text-gray-400"
                          aria-label="Licenses menu"
                        >
                          <MoreVertical className="w-4 h-4" />
                        </button>
                      </div>
                    </div>
                    <div className="overflow-auto flex-1">
                      <table className="w-full text-left text-sm min-w-full">
                        <thead className="text-gray-500 uppercase bg-gray-800 sticky top-0 z-10 whitespace-nowrap">
                          <tr>
                            <th className="p-3">Info</th>
                            <th className="p-3">Plan</th>
                            <th className="p-3">Status</th>
                            <th className="p-3 text-right">Actions</th>
                          </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-800">
                          {adminData.licenses.map((lic) => (
                            <React.Fragment key={lic._id}>
                              <tr
                                className={`hover:bg-gray-800/50 transition ${lic.status === "banned" ? "bg-red-900/20 opacity-75" : ""}`}
                              >
                                <td className="p-3 align-top">
                                  <div className="font-medium text-white">
                                    {lic.purchaser_email}
                                  </div>
                                  <div className="font-mono text-yellow-500 text-xs mt-1 break-all">
                                    {lic.license_key}
                                  </div>
                                </td>
                                <td className="p-3">
                                  <div className="font-bold text-white">
                                    {lic.max_users} Users
                                  </div>
                                  <div className="text-xs text-gray-400">
                                    {calcMonths(
                                      lic.start_date,
                                      lic.expiry_date,
                                    )}{" "}
                                    Mo
                                  </div>
                                </td>
                                <td className="p-3">
                                  <span
                                    className={`text-[10px] px-2 py-1 rounded border uppercase font-bold ${lic.status === "active" ? "border-green-500 text-green-500" : "border-red-500 text-red-500"}`}
                                  >
                                    {lic.status}
                                  </span>
                                </td>
                                <td className="p-3 text-right flex justify-end gap-2 mt-2">
                                  <button
                                    onClick={() =>
                                      setExpandedLicense(
                                        expandedLicense === lic.license_key
                                          ? null
                                          : lic.license_key,
                                      )
                                    }
                                    className={`p-2 transition rounded ${expandedLicense === lic.license_key ? "bg-qrypt-primary text-white" : "border border-gray-600 text-gray-400 hover:text-white"}`}
                                  >
                                    <Users className="w-4 h-4" />
                                  </button>
                                  {lic.status !== "banned" && (
                                    <button
                                      onClick={() =>
                                        handleAction(
                                          api.updateLicenseStatus,
                                          {
                                            license_key: lic.license_key,
                                            status:
                                              lic.status === "active"
                                                ? "suspended"
                                                : "active",
                                          },
                                          "Status Updated",
                                        )
                                      }
                                      className="p-2 transition rounded hover:bg-gray-700"
                                    >
                                      {lic.status === "active" ? (
                                        <Pause className="w-4 h-4 text-orange-400" />
                                      ) : (
                                        <Play className="w-4 h-4 text-green-400" />
                                      )}
                                    </button>
                                  )}
                                  <button
                                    onClick={() =>
                                      handleToggleBan(
                                        lic.purchaser_email,
                                        lic.status === "banned",
                                      )
                                    }
                                    className="p-2 transition rounded hover:bg-gray-700"
                                  >
                                    {lic.status === "banned" ? (
                                      <CheckCircle className="w-4 h-4 text-blue-400" />
                                    ) : (
                                      <Ban className="w-4 h-4 text-red-500" />
                                    )}
                                  </button>
                                </td>
                              </tr>
                              {expandedLicense === lic.license_key && (
                                <tr className="bg-gray-800 border-b-2 border-qrypt-primary shadow-inner">
                                  <td colSpan="4" className="p-4">
                                    <div className="flex justify-between items-center mb-3">
                                      <h4 className="font-bold text-gray-200">
                                        Authorized Users
                                      </h4>
                                      <button
                                        onClick={() => {
                                          const e = prompt("Email:");
                                          if (e)
                                            handleAction(
                                              api.adminAddEmployee,
                                              {
                                                license_key: lic.license_key,
                                                employee_email: e,
                                              },
                                              "User Added",
                                            );
                                        }}
                                        className="text-xs bg-qrypt-primary hover:bg-blue-600 transition px-3 py-1 rounded text-white font-bold"
                                      >
                                        + Add
                                      </button>
                                    </div>
                                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                                      {lic.valid_emails?.length > 0 ? (
                                        lic.valid_emails.map((emp) => {
                                          const isOwner =
                                            emp === lic.purchaser_email;
                                          return (
                                            <div
                                              key={emp}
                                              className="flex justify-between items-center bg-gray-900 border border-gray-700 p-2 rounded text-xs text-gray-300"
                                            >
                                              <span className="truncate flex items-center gap-2">
                                                {emp}
                                                {isOwner && (
                                                  <span className="text-[9px] bg-qrypt-primary text-white px-1.5 py-0.5 rounded uppercase font-bold">
                                                    Owner
                                                  </span>
                                                )}
                                              </span>
                                              <div className="flex gap-2 ml-2">
                                                {!isOwner && (
                                                  <>
                                                    <button
                                                      onClick={() => {
                                                        const e = prompt(
                                                          "New email:",
                                                          emp,
                                                        );
                                                        if (e && e !== emp)
                                                          handleAction(
                                                            api.adminEditEmployee,
                                                            {
                                                              license_key:
                                                                lic.license_key,
                                                              old_email: emp,
                                                              new_email: e,
                                                            },
                                                            "Email Updated",
                                                          );
                                                      }}
                                                      className="text-blue-400 hover:text-white transition"
                                                    >
                                                      <Edit className="w-3.5 h-3.5" />
                                                    </button>
                                                    <button
                                                      onClick={() =>
                                                        handleAction(
                                                          api.adminRemoveEmployee,
                                                          {
                                                            license_key:
                                                              lic.license_key,
                                                            employee_email: emp,
                                                          },
                                                          "Remove User?",
                                                        )
                                                      }
                                                      className="text-red-400 hover:text-white transition"
                                                    >
                                                      <Trash2 className="w-3.5 h-3.5" />
                                                    </button>
                                                  </>
                                                )}
                                              </div>
                                            </div>
                                          );
                                        })
                                      ) : (
                                        <span className="text-xs text-gray-500 italic">
                                          No users attached.
                                        </span>
                                      )}
                                    </div>
                                  </td>
                                </tr>
                              )}
                            </React.Fragment>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                {/* ── Row 2: Coupons + Force Generate (full width) ── */}
                <div className="grid gap-6 sm:grid-cols-2 items-stretch">
                  {/* Coupons */}
                  <section
                    className={`${sectionBackground} space-y-4 flex flex-col`}
                  >
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-2">
                        <Tag className="w-5 h-5 text-green-400" />
                        <p className="text-sm font-semibold uppercase tracking-wider text-white">
                          Coupons
                        </p>
                      </div>
                      <button
                        className="p-1.5 rounded-lg hover:bg-white/10 text-gray-400"
                        aria-label="Coupons menu"
                      >
                        <MoreVertical className="w-4 h-4" />
                      </button>
                    </div>
                    <form
                      onSubmit={(e) => {
                        e.preventDefault();
                        handleAction(
                          api.createCoupon,
                          couponData,
                          "Coupon Created",
                        );
                        setCouponData({
                          code: "",
                          discount: 10,
                          valid_days: 30,
                        });
                      }}
                      className="space-y-3"
                    >
                      <div className="flex gap-2">
                        <input
                          type="text"
                          placeholder="Code"
                          className="flex-1 bg-white/5 border border-white/10 rounded-2xl px-3 py-2 text-sm text-white placeholder:text-gray-500 focus:outline-none focus:ring-1 focus:ring-green-500 uppercase"
                          value={couponData.code}
                          onChange={(e) =>
                            setCouponData({
                              ...couponData,
                              code: e.target.value,
                            })
                          }
                          required
                        />
                        <input
                          type="number"
                          placeholder="%"
                          className="w-16 bg-white/5 border border-white/10 rounded-2xl px-3 py-2 text-sm text-white"
                          value={couponData.discount}
                          onChange={(e) =>
                            setCouponData({
                              ...couponData,
                              discount: e.target.value,
                            })
                          }
                          required
                        />
                      </div>
                      <button
                        type="submit"
                        className="w-full bg-green-600 hover:bg-green-700 text-xs font-bold uppercase tracking-[0.3em] py-2.5 rounded-2xl"
                      >
                        Add Coupon
                      </button>
                    </form>
                    <div className="space-y-2 overflow-auto pr-1 flex-1">
                      {couponList.length === 0 ? (
                        <p className="text-xs italic text-gray-500">
                          No coupons created yet.
                        </p>
                      ) : (
                        couponList.map((c) => (
                          <div
                            key={c.code}
                            className="bg-white/5 border border-white/5 rounded-2xl p-3 flex justify-between items-center"
                          >
                            <div>
                              <p className="font-semibold text-white">
                                {c.code}
                              </p>
                              <p className="text-xs text-gray-400">
                                {c.discount_percent}% Off
                              </p>
                            </div>
                            <div className="flex items-center gap-2">
                              <button
                                onClick={() => {
                                  const p = prompt(
                                    "New discount %:",
                                    c.discount_percent,
                                  );
                                  if (p)
                                    handleAction(
                                      api.editCoupon,
                                      { code: c.code, new_discount: p },
                                      "Coupon Updated",
                                    );
                                }}
                                className="text-blue-400"
                              >
                                <Edit className="w-3.5 h-3.5" />
                              </button>
                              <button
                                onClick={() =>
                                  handleAction(
                                    api.deleteCoupon,
                                    { code: c.code },
                                    "Coupon Deleted",
                                  )
                                }
                                className="text-red-400"
                              >
                                <Trash2 className="w-3.5 h-3.5" />
                              </button>
                            </div>
                          </div>
                        ))
                      )}
                    </div>
                  </section>

                  {/* Force Generate License */}
                  <section
                    className={`${sectionBackground} space-y-4 flex flex-col`}
                  >
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-2">
                        <Plus className="w-5 h-5 text-red-400" />
                        <p className="text-sm font-semibold uppercase tracking-wider text-white">
                          Force Generate License
                        </p>
                      </div>
                      <button
                        className="p-1.5 rounded-lg hover:bg-white/10 text-gray-400"
                        aria-label="Force menu"
                      >
                        <MoreVertical className="w-4 h-4" />
                      </button>
                    </div>
                    <form
                      onSubmit={handleGenerate}
                      className="space-y-3 flex flex-col flex-1"
                    >
                      <input
                        type="email"
                        placeholder="Client Email"
                        className="w-full bg-white/5 border border-white/10 rounded-2xl px-3 py-2 text-sm text-white placeholder:text-gray-500 focus:outline-none focus:ring-1 focus:ring-red-500"
                        value={formData.email}
                        onChange={(e) =>
                          setFormData({ ...formData, email: e.target.value })
                        }
                        required
                      />
                      <div className="grid grid-cols-2 gap-3">
                        <input
                          type="number"
                          placeholder="Users"
                          className="bg-white/5 border border-white/10 rounded-2xl px-3 py-2 text-sm text-white"
                          value={formData.users}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              users: parseInt(e.target.value, 10) || 0,
                            })
                          }
                        />
                        <input
                          type="number"
                          placeholder="Months"
                          className="bg-white/5 border border-white/10 rounded-2xl px-3 py-2 text-sm text-white"
                          value={formData.months}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              months: parseInt(e.target.value, 10) || 0,
                            })
                          }
                        />
                      </div>
                      <button
                        type="submit"
                        className="w-full bg-red-600 hover:bg-red-700 text-xs font-bold uppercase tracking-[0.3em] py-2.5 rounded-2xl mt-auto"
                      >
                        Generate Free Key
                      </button>
                    </form>
                  </section>
                </div>
              </div>
            )}

            {(activeTab === "users" || activeTab === "deleted") && (
              <div className="grid lg:grid-cols-12 gap-8">
                <div className="lg:col-span-4 bg-gray-900 p-6 rounded-xl border border-gray-700 h-fit max-h-[800px] overflow-auto">
                  <h2 className="text-xl font-bold mb-4 flex items-center gap-2">
                    <Search className="w-5 h-5 text-gray-400" /> Directory
                  </h2>
                  <div className="space-y-2">
                    {(activeTab === "users"
                      ? adminData.usersList
                      : adminData.deletedList
                    ).map((u) => (
                      <div
                        key={u._id}
                        onClick={() => loadUserDetails(u.email)}
                        className={`p-4 rounded-lg cursor-pointer transition border ${adminData.userDetails?.profile?.email === u.email ? "bg-qrypt-primary/20 border-qrypt-primary" : "bg-gray-800 border-gray-700 hover:bg-gray-700"}`}
                      >
                        <div className="flex justify-between items-center">
                          <div>
                            <p className="font-bold text-sm">
                              {u.name || "No Name"}
                            </p>
                            <p className="text-xs text-gray-400">{u.email}</p>
                          </div>
                          <span
                            className={`text-[10px] px-2 py-1 rounded uppercase font-bold border ${activeTab === "deleted" || u.is_banned ? "border-red-500 text-red-500" : "border-green-500 text-green-500"}`}
                          >
                            {activeTab === "deleted"
                              ? "DELETED"
                              : u.is_banned
                                ? "BANNED"
                                : "ACTIVE"}
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="lg:col-span-8">
                  {adminData.detailsLoading ? (
                    <div className="text-center p-10 bg-gray-900 rounded-xl text-gray-400">
                      Loading...
                    </div>
                  ) : !adminData.userDetails ? (
                    <div className="text-center p-10 bg-gray-900 border border-gray-700 rounded-xl text-gray-500">
                      Select an account from the list.
                    </div>
                  ) : (
                    <div className="space-y-6">
                      <div className="bg-gray-900 p-6 rounded-xl border border-gray-700 shadow-xl">
                        <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between border-b border-gray-800 pb-4 mb-4">
                          <h2 className="text-xl font-bold flex items-center gap-2">
                            User Profile
                          </h2>
                          <div className="flex flex-wrap gap-2">
                            {activeTab !== "deleted" && (
                              <button
                                onClick={() =>
                                  handleToggleBan(
                                    adminData.userDetails.profile.email,
                                    adminData.userDetails.profile.is_banned,
                                  )
                                }
                                className={`px-4 py-1.5 rounded text-sm font-bold flex items-center gap-2 ${adminData.userDetails.profile.is_banned ? "bg-green-600 hover:bg-green-500" : "bg-orange-600 hover:bg-orange-500"}`}
                              >
                                {adminData.userDetails.profile.is_banned ? (
                                  <>
                                    <CheckCircle className="w-4 h-4" /> Unban
                                    Account
                                  </>
                                ) : (
                                  <>
                                    <Ban className="w-4 h-4" /> Suspend Account
                                  </>
                                )}
                              </button>
                            )}
                            {!editMode ? (
                              <button
                                onClick={() => setEditMode(true)}
                                className="bg-blue-600 hover:bg-blue-500 px-4 py-1.5 rounded text-sm font-bold flex items-center gap-2"
                              >
                                <Edit className="w-4 h-4" /> Edit Profile
                              </button>
                            ) : (
                              <button
                                onClick={() => setEditMode(false)}
                                className="bg-gray-600 hover:bg-gray-500 px-4 py-1.5 rounded text-sm font-bold"
                              >
                                Cancel
                              </button>
                            )}
                            {activeTab !== "deleted" && (
                              <button
                                onClick={() =>
                                  handleDeleteUser(
                                    adminData.userDetails.profile.email,
                                  )
                                }
                                className="bg-red-600 hover:bg-red-500 px-4 py-1.5 rounded text-sm font-bold flex items-center gap-2"
                              >
                                <Trash2 className="w-4 h-4" /> Delete
                              </button>
                            )}
                          </div>
                        </div>

                        {!editMode ? (
                          <div className="grid grid-cols-2 gap-4 text-sm">
                            <div>
                              <p className="text-gray-500">Name</p>
                              <p className="font-bold text-lg">
                                {adminData.userDetails.profile.name}
                              </p>
                            </div>
                            <div>
                              <p className="text-gray-500">Email</p>
                              <p className="font-bold">
                                {adminData.userDetails.profile.email}
                              </p>
                            </div>
                            <div>
                              <p className="text-gray-500">Account Type</p>
                              <p className="font-bold capitalize">
                                {adminData.userDetails.profile.account_type}
                              </p>
                            </div>
                            {adminData.userDetails.profile.account_type ===
                              "organisation" && (
                              <>
                                <div>
                                  <p className="text-gray-500">Org Name</p>
                                  <p className="font-bold">
                                    {adminData.userDetails.profile.org_details}
                                  </p>
                                </div>
                                <div>
                                  <p className="text-gray-500">GST Number</p>
                                  <p className="font-bold uppercase">
                                    {adminData.userDetails.profile.gst_number ||
                                      "N/A"}
                                  </p>
                                </div>
                              </>
                            )}
                          </div>
                        ) : (
                          <form
                            onSubmit={handleUpdateUser}
                            className="space-y-4"
                          >
                            <input
                              type="text"
                              className="w-full bg-gray-800 p-2 rounded outline-none text-white border border-gray-700"
                              value={editedUser.name}
                              onChange={(e) =>
                                setEditedUser({
                                  ...editedUser,
                                  name: e.target.value,
                                })
                              }
                              required
                              placeholder="Full Name"
                            />
                            <select
                              className="w-full bg-gray-800 p-2 rounded outline-none text-white border border-gray-700"
                              value={editedUser.account_type}
                              onChange={(e) =>
                                setEditedUser({
                                  ...editedUser,
                                  account_type: e.target.value,
                                })
                              }
                            >
                              <option value="single">Single User</option>
                              <option value="organisation">Organisation</option>
                            </select>
                            {editedUser.account_type === "organisation" && (
                              <>
                                <input
                                  type="text"
                                  className="w-full bg-gray-800 p-2 rounded outline-none text-white border border-gray-700"
                                  value={editedUser.org_details}
                                  onChange={(e) =>
                                    setEditedUser({
                                      ...editedUser,
                                      org_details: e.target.value,
                                    })
                                  }
                                  placeholder="Org Name"
                                  required
                                />
                                <input
                                  type="text"
                                  className="w-full bg-gray-800 p-2 rounded outline-none text-white uppercase border border-gray-700"
                                  value={editedUser.gst_number}
                                  onChange={(e) =>
                                    setEditedUser({
                                      ...editedUser,
                                      gst_number: e.target.value,
                                    })
                                  }
                                  placeholder="GST"
                                />
                              </>
                            )}
                            <button
                              type="submit"
                              className="bg-green-600 hover:bg-green-500 px-6 py-2 rounded font-bold w-full"
                            >
                              Save Changes
                            </button>
                          </form>
                        )}
                      </div>

                      <h3 className="text-lg font-bold text-gray-400 mt-6 flex items-center gap-2">
                        <Activity className="w-5 h-5" /> Account Activity &
                        Licenses
                      </h3>
                      {adminData.userDetails.licenses.map((lic) => (
                        <div
                          key={lic.license_key}
                          className="bg-gray-800 p-6 rounded-xl border border-gray-700"
                        >
                          <div className="flex justify-between items-start border-b border-gray-700 pb-4 mb-4">
                            <div>
                              <p className="font-mono text-yellow-500 text-lg">
                                {lic.license_key}
                              </p>
                              <p className="text-sm text-gray-400 mt-1">
                                Capacity: {lic.valid_emails?.length || 0} /{" "}
                                {lic.max_users} Users
                              </p>
                            </div>
                            <span
                              className={`text-[10px] px-2 py-1 rounded uppercase font-bold border ${lic.status === "active" ? "border-green-500 text-green-500" : "border-red-500 text-red-500"}`}
                            >
                              {lic.status}
                            </span>
                          </div>
                          {lic.valid_emails?.length > 0 ? (
                            <div className="flex flex-wrap gap-2">
                              {lic.valid_emails.map((e) => {
                                const isOwner = e === lic.purchaser_email;
                                return (
                                  <span
                                    key={e}
                                    className="bg-gray-900 px-3 py-1 rounded text-xs border border-gray-700 flex items-center gap-2"
                                  >
                                    {e}
                                    {isOwner && (
                                      <span className="text-[9px] bg-qrypt-primary text-white px-1.5 py-0.5 rounded uppercase font-bold">
                                        Owner
                                      </span>
                                    )}
                                  </span>
                                );
                              })}
                            </div>
                          ) : (
                            <p className="text-xs text-gray-500 italic">
                              No employees connected.
                            </p>
                          )}
                        </div>
                      ))}
                      {adminData.userDetails.licenses.length === 0 && (
                        <p className="text-gray-500 italic bg-gray-900 p-4 rounded text-center border border-dashed border-gray-700">
                          No purchase history found for this account.
                        </p>
                      )}
                    </div>
                  )}
                </div>
              </div>
            )}
          </main>

          <footer className="px-4 sm:px-6 lg:px-8 pb-6 text-gray-500 text-sm">
            <div className="border-t border-white/10 pt-4 flex flex-col sm:flex-row gap-3 sm:items-center sm:justify-between">
              <span>© {new Date().getFullYear()} QryptShield</span>
              <span className="text-gray-400">Super Admin Control Plane</span>
            </div>
          </footer>
        </div>
      </div>
    </div>
  );
};

export default Admin;
